module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/relation_link_pregnant_down-e75b8d6dc57ee1a9f466d40eff374713.png";